import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { PlusCircle, Edit } from "react-feather";
import OfferDetailsView from "../Marketing/offerPreview";
import { getMediaPlansList, getMediaPlanById } from "../../core/api/mediaplan";
import { createFetchMediaPlansFunction } from "./fetchMediaPlans.js";
import { useSelector, useDispatch } from "react-redux";
import { Eye, RotateCcw, ChevronUp } from "feather-icons-react/build/IconComponents";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import ProductDetailsView from "../inventory/productDetailsView";
import { OverlayTrigger, Tooltip as BSTooltip } from "react-bootstrap";
import { setToogleHeader } from "../../core/redux/action";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { secureExportToExcel } from "../../utils/secureExcelUtils";
import { Tabs, message, Button } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import EditMediaPlan from "./editmediaplan";
import TimelineTable from "./product_timiline";
import ProductOrderPrediction from "./productOrderPrediction";
import ROR100Days from "./RoR_100_days";
import Lists from "./lists";
import { useParams } from "react-router-dom";
import { getCurrentUser } from "../../core/api/settings";
import { getProfile } from "../../core/api/auth";
import ViewMediaPlan from "./components/viewMediaPlan";
import MediaPlanFilter from "./components/MediaPlanFilter";
import { AgGridReact } from "ag-grid-react";
import "../../style/css/feather.css";

const { TabPane } = Tabs;
const localizer = momentLocalizer(moment);
const MediaPlanList = () => {
  const [mediaplanMode, setMediaplanMode] = useState("create");
  const { mode: urlMode, clientId: urlClientId, mediaPlanId: urlMediaPlanId } = useParams();

  useEffect(() => {
    if (urlMode) setMediaplanMode(urlMode);
    if (urlClientId) setClientId(urlClientId);
    if (urlMediaPlanId) setMediaPlanId(urlMediaPlanId);
  }, [urlMode, urlClientId, urlMediaPlanId]);

  const { campaignCode } = useParams();
  const [mediaPlans, setMediaPlans] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5000);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const gridApiRef = useRef(null);
  const profile = useSelector((state) => state.profile);
  // Ref to track in-flight request key to avoid duplicates
  const pendingRequestRef = useRef(null);
  const selectedClients = useSelector((state) => state.selectedClients);
  const [currentVariationId, setCurrentVariationId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [offerId, setOfferId] = useState(null);
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const [clientId, setClientId] = useState(null);
  const sidebarRef = useRef(null);
  const [sidebarWidth, setSidebarWidth] = useState(0);
  const [isRightSideBarEditMode, setIsRightSideBarEditMode] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [mediaPlanId, setMediaPlanId] = useState(null);
  const [forcedTabKey, setForcedTabKey] = useState(null);
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const [openMediaTabs, setOpenMediaTabs] = useState([]);

  const [viewMode, setViewMode] = useState("list"); // 'list', 'calendar', or 'weekly'
  const [calendarDateRange, setCalendarDateRange] = useState({
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().endOf("month").format("YYYY-MM-DD"),
    view: "month",
  });

  // Filter-related state (matching Sales Dashboard pattern)
  const [filtersMinimized, setFiltersMinimized] = useState(() => {
    // Get the saved state from localStorage or default to false if not found
    const savedState = localStorage.getItem("mediaPlanFiltersMinimized");
    return savedState ? JSON.parse(savedState) : false;
  });

  const [userSelectedFilters, setUserSelectedFilters] = useState({
    dateRange: null,
    brands: [],
    products: [],
    strategies: [],
    campaignCodes: [],
    offerCodifications: [],
  });

  useEffect(() => {
    const fetchByCampaignCode = async () => {
      if (!campaignCode) return;

      const tabKey = `view-${campaignCode}`;
      const exists = openViewTabs.some((tab) => tab.key === tabKey);
      if (exists) return;

      try {
        const response = await getMediaPlansList(selectedClients, 1, 1000);
        const matchingPlan = response.data.results.find(
          (plan) => plan.campaign_code === campaignCode
        );

        if (matchingPlan) {
          setOpenViewTabs((prev) => [
            ...prev,
            {
              key: tabKey,
              label: `View ${matchingPlan.campaign_code}`,
              content: (
                <ViewMediaPlan
                  key={`view-tab-${campaignCode}`}
                  mediaPlanId={matchingPlan.id}
                  clientId={matchingPlan.offer_details.client.id}
                />
              ),
              closable: true,
            },
          ]);
          setForcedTabKey(tabKey);
          setActiveViewTabKey(tabKey);
        } else {
          message.error("Campaign code not found.");
        }
      } catch (error) {
        console.error("Failed to fetch media plan for campaign code", error);
        message.error("Failed to load campaign view.");
      }
    };

    fetchByCampaignCode();
  }, [campaignCode]);

  useEffect(() => {
    const loadTabWithCampaignCode = async () => {
      if (urlMode === "view" && urlClientId && urlMediaPlanId) {
        const tabKey = `view-${urlClientId}-${urlMediaPlanId}`;
        const exists = openViewTabs.some((tab) => tab.key === tabKey);

        if (!exists) {
          try {
            const response = await getMediaPlanById(urlClientId, urlMediaPlanId);
            const campaignCode = response?.data?.campaign_code || urlMediaPlanId;

            setOpenViewTabs((prev) => [
              ...prev,
              {
                key: tabKey,
                label: `View ${campaignCode}`,
                content: (
                  <ViewMediaPlan
                    key={`view-${mediaPlanId}`}
                    mediaPlanId={urlMediaPlanId}
                    clientId={urlClientId}
                  />
                ),
                closable: true,
              },
            ]);
          } catch (error) {
            console.error("Failed to fetch media plan for tab label", error);
          }
        }

        setForcedTabKey(tabKey);
        setActiveViewTabKey(tabKey);
      }
    };

    loadTabWithCampaignCode();
  }, [urlMode, urlClientId, urlMediaPlanId]);

  // 1) Update your mapping to include the full path for “campaign”:
  const tabKeyToPath = {
    1: "campaigns", // → /media-plans
    2: "campaign", // → /media-plans/campaign/…
    3: "purchase-order-evolution", // → /media-plans/purchase-order-evolution
    4: "ror-100-days", // → /media-plans/ror-100-days
    5: "lists", // → /media-plans/lists
    6: "view-media-plan", // -> /media-plans/view
  };

  const pathToTabKey = Object.entries(tabKeyToPath).reduce((acc, [key, path]) => {
    acc[path] = key;
    return acc;
  }, {});

  const computedKey = pathToTabKey[location.pathname.split("/")[2]] || "1";
  const activeTabKey = forcedTabKey || computedKey;

  const toggleSidebarEditMode = () => {
    setIsRightSideBarEditMode((prevMode) => !prevMode);
  };
  const toggleSidebarEditModeStock = () => {
    setIsEditMode((prevMode) => !prevMode);
  };
  const handleCloseRightSideBar = () => {
    setSidebarVisible(false);
    setClientId(selectedClients[0]);
    setOfferId(null);
    setIsRightSideBarEditMode(false);
    fetchMediaPlans();
  };

  const [isEditMode, setIsEditMode] = useState(false);
  const [productId, setProductId] = useState(null);
  const [openViewTabs, setOpenViewTabs] = useState([]);
  const [activeViewTabKey, setActiveViewTabKey] = useState(null);

  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const renderExcelTooltip = (props) => (
    <BSTooltip id="excel-tooltip" {...props}>
      Excel
    </BSTooltip>
  );
  const renderCollapseTooltip = (props) => (
    <BSTooltip id="refresh-tooltip" {...props}>
      Collapse
    </BSTooltip>
  );
  const renderRefreshTooltip = (props) => (
    <BSTooltip id="refresh-tooltip" {...props}>
      Refresh
    </BSTooltip>
  );

  useEffect(() => {
    const updateSidebarWidth = () => {
      if (sidebarRef.current) {
        setSidebarWidth(sidebarRef.current.getBoundingClientRect().width);
      }
    };

    if (isSidebarVisible) {
      updateSidebarWidth();
      window.addEventListener("resize", updateSidebarWidth);
    }

    return () => {
      window.removeEventListener("resize", updateSidebarWidth);
    };
  }, [isSidebarVisible]);

  useEffect(() => {
    const fetchPermissions = async () => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      if (token) {
        try {
          sessionStorage.setItem("page_permissions", JSON.stringify(profile?.page_permissions));
          sessionStorage.setItem("page_authorization", JSON.stringify(profile?.page_authorization));
          sessionStorage.setItem("user_role", user.role);
        } catch (e) {
          console.error("Failed to fetch permissions", e);
        }
      }
    };
    fetchPermissions();
  }, [profile]);

  // Initialize the fetchMediaPlans function with performance monitoring
  const fetchMediaPlans = useCallback(
    createFetchMediaPlansFunction(
      getMediaPlansList,
      setMediaPlans,
      setPage,
      setTotalPages,
      setTotalItems,
      setHasMore,
      (value) => setDataLoaded(value),
      setLoading,
      setIsLoadingMore,
      gridApiRef,
      pendingRequestRef,
      selectedClients
    ),
    [selectedClients]
  );

  useEffect(() => {
    fetchMediaPlans(1, pageSize, viewMode === "calendar", userSelectedFilters);
  }, [fetchMediaPlans, selectedClients, userSelectedFilters, pageSize, viewMode]);

  useEffect(() => {
    if (viewMode === "calendar") {
      fetchMediaPlans(1, 5000, true, userSelectedFilters);
    }
  }, [viewMode, calendarDateRange, fetchMediaPlans, userSelectedFilters]);

  // Effect to sync localStorage with state changes
  useEffect(() => {
    localStorage.setItem("mediaPlanFiltersMinimized", JSON.stringify(filtersMinimized));
  }, [filtersMinimized]);

  const handleFilterChange = useCallback(
    (newFilters) => {
      setUserSelectedFilters(newFilters);
      setPage(1);
      fetchMediaPlans(1, pageSize, viewMode === "calendar", newFilters);
    },
    [fetchMediaPlans, pageSize, viewMode]
  );

  const handleAddNewMediaPlan = async () => {
    if (selectedClients.length === 0) {
      message.warning("Please select a client.");
      return;
    }

    if (selectedClients.length > 1) {
      message.warning("Please select one client.");
      return;
    }

    if (selectedClients[0] === "all") {
      message.warning("Please select one client.");
      return;
    }

    setClientId(selectedClients[0]);
    setMediaplanMode("create");
    setForcedTabKey("2");
    navigate(`/media-plans/campaign/create/${selectedClients[0]}`);
  };

  useEffect(() => {
    if (forcedTabKey === "2" && clientId && mediaPlanId) {
      navigate(`/media-plans/campaign/edit/${clientId}/${mediaPlanId}`);
    }
  }, [forcedTabKey, clientId, mediaPlanId, navigate]);

  const columnDefs = [
    {
      headerName: "#",
      valueGetter: (params) => {
        return (page - 1) * pageSize + params.node.rowIndex + 1;
      },
      width: 70,
      sortable: false,
      filter: false,
      pinned: "left",
    },
    {
      headerName: "Brand",
      field: "offer_details.brand_name",
      valueGetter: (p) => p.data.offer_details?.brand_name,
      width: 130,
    },
    {
      headerName: "Mail Date",
      field: "date",
      width: 130,
      valueFormatter: (p) => (p.value ? new Date(p.value).toLocaleDateString() : ""),
    },
    {
      headerName: "Status",
      field: "status.name",
      width: 120,
      cellRenderer: (p) => {
        const status = p.data.status?.name;
        const badgeClass = status === "Confirmed" ? "badge bg-success" : "badge bg-danger";
        return <span className={badgeClass}>{status}</span>;
      },
    },
    {
      headerName: "Campaign Code",
      field: "campaign_code",
      pinned: "left",
      width: 150,
      cellRenderer: (p) => {
        const code = p.data.campaign_code;
        return (
          <span
            className="clickable-link"
            onClick={() => {
              const tabKey = `view-${p.data.id}`;
              const exists = openViewTabs.some((tab) => tab.key === tabKey);
              if (!exists) {
                setOpenViewTabs((prev) => [
                  ...prev,
                  {
                    key: tabKey,
                    label: `View ${code}`,
                    content: (
                      <ViewMediaPlan
                        mediaPlanId={p.data.id}
                        clientId={p.data.offer_details.client.id}
                      />
                    ),
                    closable: true,
                  },
                ]);
              }
              setForcedTabKey(tabKey);
              setActiveViewTabKey(tabKey);
            }}>
            <u>{code}</u>
          </span>
        );
      },
    },
    {
      headerName: "Offer Codification",
      field: "offer_details.code_offer",
      width: 150,
      cellRenderer: (p) => {
        const code = p.data.offer_details?.code_offer;
        return (
          <span
            className="clickable-link"
            onClick={() => {
              setClientId(p.data.offer_details.client.id);
              setOfferId(p.data.offer_details.id);
              setIsRightSideBarEditMode(false);
              setSidebarVisible(true);
            }}>
            <u>{code}</u>
          </span>
        );
      },
    },
    {
      headerName: "Product Variation Description",
      field: "offer_details.product_variations_detail",
      width: 270,
      cellRenderer: (p) => {
        const variations = Array.isArray(p.data.offer_details?.product_variations_detail)
          ? p.data.offer_details.product_variations_detail
          : [];
        return (
          <ul className="mb-0">
            {variations.map((v) => (
              <li key={v.id}>
                <span
                  className="clickable-link"
                  onClick={() => {
                    navigate(
                      `/products/view/${p.data.offer_details.client.id}/${v.product_id}${
                        v.id ? `/${v.id}` : ""
                      }${v.warehouse_id ? `/${v.warehouse_id}` : ""}`
                    );
                  }}>
                  <u>{v.description}</u>
                </span>
              </li>
            ))}
          </ul>
        );
      },
    },

    {
      headerName: "Strategy",
      field: "strategy.strategy",
      valueGetter: (p) => p.data.strategy?.strategy,
      width: 130,
    },
    {
      headerName: "Target Mail Qty",
      field: "target_mail_qty",
      sortable: true,
      width: 130,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Target Rate of Response %",
      field: "target_rate_of_response",
      sortable: true,
      width: 120,
      valueFormatter: (p) => `${p.value || 0}%`,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Printer",
      field: "printer.name",
      valueGetter: (p) => p.data.printer?.name,
      width: 100,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Printing",
      field: "printing_cost",
      width: 100,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Lettershop",
      field: "lettershop_cost",
      width: 120,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Postage",
      field: "postage_cost",
      width: 100,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Data Processing",
      field: "data_processing_cost",
      width: 110,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Misc Fee",
      field: "misc_fee",
      width: 110,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Lists Cost",
      field: "lists_cost",
      width: 100,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Merchant Fee",
      field: "merchant_fee",
      width: 120,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Product Cost",
      field: "product_cost",
      width: 120,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Call Center Cost",
      field: "call_center_cost",
      width: 140,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Shipping Cost",
      field: "shipping_cost",
      width: 120,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Fulfillment Cost",
      field: "fulfillment_cost",
      width: 140,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Royalty",
      field: "royalty",
      width: 100,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Refund Cost",
      field: "refund_cost",
      width: 120,
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Actions",
      field: "action",
      pinned: "right",
      width: 100,
      filter: false,
      cellRenderer: (p) => {
        const record = p.data;
        return (
          <div className="action-table-data edit-delete-action d-flex gap-1">
            <Link
              className="p-1"
              title="Preview"
              onClick={() => {
                const mediaPlanId = record.id;
                const tabKey = `view-${mediaPlanId}`;
                const exists = openViewTabs.some((tab) => tab.key === tabKey);
                if (!exists) {
                  setOpenViewTabs((prev) => [
                    ...prev,
                    {
                      key: tabKey,
                      label: `View ${record.campaign_code || mediaPlanId}`,
                      content: (
                        <ViewMediaPlan key={`view-tab-${mediaPlanId}`} mediaPlanId={mediaPlanId} />
                      ),
                      closable: true,
                    },
                  ]);
                }
                setForcedTabKey(tabKey);
                navigate(`/media-plans/view/${mediaPlanId}`);
                setActiveViewTabKey(tabKey);
              }}>
              <Eye className="feather-view" style={{ width: 16, height: 16 }} />
            </Link>

            <Link
              className="p-1"
              title="Edit"
              onClick={() => {
                setClientId(record.offer_details.client.id);
                setMediaPlanId(record.id);
                setForcedTabKey("2");
              }}>
              <Edit className="feather-edit" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
        );
      },
    },
  ];

  const [isMediaPlanSidebarVisible, setIsMediaPlanSideBarVisible] = useState(false);
  const [selectedMediaPlanId, setSelectedMediaPlanId] = useState(null);
  const [isMediaPlanEditMode, setIsMediaPlanEditMode] = useState(false);
  const [mediaPlanSidebarWidth, setMediaPlanSidebarWidth] = useState(0);
  const handleMediaPlanCloseSidebar = () => {
    setIsMediaPlanSideBarVisible(false);
    setClientId(selectedClients[0]);
    setIsMediaPlanEditMode(false);
    setSelectedMediaPlanId(null);
    fetchMediaPlans();
  };
  const sidebarMediaPlanRef = useRef(null);
  const toggleMediaPlanEditMode = () => {
    setIsMediaPlanEditMode((prevMode) => !prevMode);
  };

  const [isProductStockSidebarVisible, setProductStockSidebarVisible] = useState(false);
  const productStockSidebarRef = useRef(null);
  const [productStockSidebarWidth, setProductStockSidebarWidth] = useState(555);
  const handleProductStockClose = () => {
    setProductStockSidebarVisible(false);
    setProductId(null);
    setIsEditMode(false);
    setCurrentVariationId(null);
  };
  const [currentTableData, setCurrentTableData] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredMediaPlans, setFilteredMediaPlans] = useState([]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchQuery(value);

    if (value) {
      const filtered = mediaPlans.filter((item) => {
        const campaignCode = item.campaign_code?.toLowerCase() || "";
        const offerName = item.offer?.offer_name?.toLowerCase() || "";
        return campaignCode.includes(value) || offerName.includes(value);
      });
      setFilteredMediaPlans(filtered);
    } else {
      setFilteredMediaPlans([]);
      fetchMediaPlans(1, pageSize, viewMode === "calendar", userSelectedFilters);
    }
  };

  const exportToExcel = () => {
    const dataToExport = viewMode === "calendar" ? mediaPlans : currentTableData;

    const exportData = dataToExport.map((plan) => ({
      Brand: plan.brand || "",
      "Mail Date": plan.date || "",
      Strategy: plan.strategy || "",
      "Product Variation": plan.product_variation_desc || "",
      "Offer Codification": plan.code_offer || "",
      "Campaign Code": plan.campaign_code || "",
      "Target Mail Qty": plan.target_mail_qty || 0,
      "Target Rate of Response (%)": `${plan.target_rate_of_response || 0}%`,
      Printer: plan.printer || "",
      "Call-Center": plan.call_center || "",
      "Phone Number": plan.phone_number || "",
    }));

    secureExportToExcel(exportData, "media_plans.xlsx");
  };

  // right before your return(…)
  const campaignTabTitle =
    mediaplanMode === "create"
      ? "Create Campaign"
      : mediaplanMode === "view"
      ? "View Campaign"
      : "Edit Campaign";

  return (
    <div className="page-wrapper">
      <div style={{ display: "flex" }}>
        <div
          className={`media-plan-sidebar ${filtersMinimized ? "minimized" : ""}`}
          style={{
            transition: "width 0.3s ease-in-out",
            width: filtersMinimized ? "50px" : "280px",
            overflow: "hidden",
            borderRight: "1px solid #dee2e6",
            backgroundColor: "#fff",
            position: "relative",
            minHeight: "calc(100vh - 120px)",
            paddingTop: "80px",
          }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 10px",
              position: "absolute",
              top: "10px",
              right: 0,
              left: 0,
              zIndex: 10,
            }}>
            {!filtersMinimized && (
              <h4 style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}>Media Plans Filter</h4>
            )}
            <Button
              type="text"
              icon={filtersMinimized ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => {
                const newState = !filtersMinimized;
                setFiltersMinimized(newState);
                localStorage.setItem("mediaPlanFiltersMinimized", JSON.stringify(newState));
              }}
              size="small"
              title={filtersMinimized ? "Expand filters" : "Collapse filters"}
            />
          </div>

          <div
            style={{
              opacity: filtersMinimized ? 0 : 1,
              transition: "opacity 0.3s ease-in-out",
            }}>
            <MediaPlanFilter
              onFilterChange={handleFilterChange}
              userSelectedFilters={userSelectedFilters}
              onClose={() => setFiltersMinimized(true)}
            />
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <div
            className={`${filtersMinimized ? "dashboard-main-expanded" : "dashboard-main"} px-2`}
            style={{
              transition: "margin-left 0.3s ease-in-out",
              marginLeft: filtersMinimized ? "40px" : "10px",
            }}>
            <div className="card">
              <div className="card-body">
                <div
                  style={{
                    display: "block",
                    alignItems: "center",
                    marginBottom: "10px",
                    width: "100%",
                  }}></div>

                <Tabs
                  type="editable-card"
                  hideAdd={true}
                  activeKey={activeTabKey}
                  onChange={(key) => {
                    setForcedTabKey(key);
                    setActiveViewTabKey(key);

                    if (key.startsWith("view-")) {
                      const campaignCode = key.replace("view-", "");
                      navigate(`/media-plans/view/${campaignCode}`);
                      return;
                    }

                    if (key === "2") {
                      if (selectedClients.length !== 1 || selectedClients[0] === "all") {
                        message.warning("Please select exactly one client.");
                        return;
                      }

                      const base = `/media-plans/campaign/${mediaplanMode}/${selectedClients[0]}`;
                      const withId = mediaPlanId ? `${base}/${mediaPlanId}` : base;
                      navigate(withId);
                      return;
                    }

                    navigate(`/media-plans/${tabKeyToPath[key]}`);
                  }}
                  onEdit={(targetKey, action) => {
                    if (action === "remove") {
                      setOpenViewTabs((prev) => prev.filter((tab) => tab.key !== targetKey));
                      if (activeTabKey === targetKey) {
                        setForcedTabKey("1");
                      }
                    }
                  }}
                  editable
                  className="p-2">
                  <TabPane tab="Media Plans" key="1" closable={false}>
                    <div
                      style={{
                        position: "relative",
                        minHeight: "calc(100vh - 120px)",
                      }}>
                      <div className="page-header">
                        <div className="add-item d-flex">
                          <div className="page-title">
                            <h4>Media Plans</h4>
                          </div>
                        </div>
                        <ul className="table-top-head">
                          <div className="search-set">
                            <div className="search-input">
                              <input
                                type="text"
                                placeholder="Search"
                                className="form-control form-control-sm formsearch"
                                value={searchQuery}
                                onChange={handleSearch}
                              />
                              <Link to="#" className="btn btn-searchset">
                                <i data-feather="search" className="feather-search" />
                              </Link>
                            </div>
                          </div>
                          <li>
                            <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                onClick={exportToExcel}>
                                <ImageWithBasePath src="assets/img/icons/xls.svg" alt="img" />
                              </Link>
                            </OverlayTrigger>
                          </li>
                          <li>
                            <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                onClick={() =>
                                  fetchMediaPlans(
                                    1,
                                    pageSize,
                                    viewMode === "calendar",
                                    userSelectedFilters
                                  )
                                }>
                                <RotateCcw />
                              </Link>
                            </OverlayTrigger>
                          </li>

                          <li>
                            <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                id="collapse-header"
                                className={data ? "active" : ""}
                                onClick={(e) => {
                                  e.preventDefault();
                                  dispatch(setToogleHeader(!data));
                                }}>
                                <ChevronUp />
                              </Link>
                            </OverlayTrigger>
                          </li>
                        </ul>
                        <div className="page-btn d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <Button
                              type="text"
                              icon={
                                filtersMinimized ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
                              }
                              onClick={() => setFiltersMinimized(!filtersMinimized)}
                              className="me-2"
                            />
                          </div>
                          <div className="dropdown me-2">
                            <button
                              className="btn btn-secondary dropdown-toggle"
                              type="button"
                              id="viewModeDropdown"
                              data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {viewMode === "list"
                                ? "List View"
                                : viewMode === "calendar"
                                ? "Calendar View"
                                : "Planning View"}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="viewModeDropdown">
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => setViewMode("list")}>
                                  List View
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => setViewMode("calendar")}>
                                  Calendar View
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => setViewMode("planning")}>
                                  Planning View
                                </button>
                              </li>
                            </ul>
                          </div>

                          <button className="btn btn-added me-2" onClick={handleAddNewMediaPlan}>
                            <PlusCircle className="me-2 iconsize" />
                            Add New Media Plan
                          </button>
                        </div>
                      </div>

                      {/* Filter Sidebar and Main Content Container */}
                      <div className="d-flex">
                        {/* Main Content Area */}
                        <div
                          className="flex-grow-1"
                          style={{
                            marginLeft: filtersMinimized ? "0" : "0",
                            transition: "margin-left 0.3s ease",
                          }}>
                          {viewMode === "list" ? (
                            <div className="p-3">
                              <div
                                className="ag-theme-quartz position-relative"
                                style={{ height: "700px", width: "100%" }}>
                                {/* Loading Overlay */}
                                {loading && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                                      zIndex: 1000,
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}>
                                    <div
                                      className="spinner-border text-primary"
                                      role="status"
                                      style={{ width: "3rem", height: "3rem" }}>
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <div
                                      style={{
                                        marginTop: "15px",
                                        fontWeight: "bold",
                                      }}>
                                      Loading media plans...
                                    </div>
                                  </div>
                                )}
                                <AgGridReact
                                  columnDefs={columnDefs}
                                  rowData={searchQuery ? filteredMediaPlans : mediaPlans}
                                  defaultColDef={{
                                    resizable: true,
                                    sortable: true,
                                    filter: true,
                                    minWidth: 50,
                                  }}
                                  pagination={true}
                                  paginationPageSize={pageSize}
                                  suppressPaginationPanel={true}
                                  domLayout="normal"
                                  rowModelType="clientSide"
                                  onGridReady={(params) => {
                                    gridApiRef.current = params.api;

                                    // If we're currently loading data, show the loading overlay
                                    if (loading) {
                                      params.api.showLoadingOverlay();
                                    }

                                    if (typeof page === "number" && !isNaN(page)) {
                                      setTimeout(() => {
                                        params.api.paginationGoToPage(page - 1);
                                      }, 0);
                                    }
                                  }}
                                  onPaginationChanged={(params) => {
                                    if (!params.api || loading) return;

                                    if (params.api.paginationProxy) {
                                      const newPage =
                                        params.api.paginationProxy.getCurrentPage() + 1;
                                      const newPageSize = params.api.paginationProxy.getPageSize();

                                      if (
                                        typeof newPage === "number" &&
                                        !isNaN(newPage) &&
                                        (newPage !== page || newPageSize !== pageSize)
                                      ) {
                                        // Show loading overlay before fetching data
                                        params.api.showLoadingOverlay();
                                        setPage(newPage);
                                        setPageSize(newPageSize);
                                        fetchMediaPlans(newPage, newPageSize);
                                      }
                                    }
                                  }}
                                  overlayNoRowsTemplate="<div style='padding: 20px; text-align: center;'>No media plans found</div>"
                                  overlayLoadingTemplate="<div style='padding: 20px; text-align: center;'><div class='spinner-border text-primary' role='status'><span class='visually-hidden'>Loading...</span></div><div style='margin-top: 10px;'>Loading media plans...</div></div>"
                                />
                                {/* Custom Pagination Footer */}
                                <div
                                  style={{
                                    position: "sticky",
                                    bottom: 0,
                                    backgroundColor: "white",
                                    padding: "10px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderTop: "1px solid #ddd",
                                    zIndex: 1000,
                                    boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
                                  }}>
                                  <div>
                                    Showing {(page - 1) * pageSize + 1} to{" "}
                                    {Math.min(page * pageSize, totalItems)} of {totalItems} entries
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}>
                                    <div style={{ marginRight: "20px" }}>
                                      <label style={{ marginRight: "5px" }}>Page Size:</label>
                                      <select
                                        value={pageSize}
                                        onChange={(e) => {
                                          const newSize = parseInt(e.target.value);
                                          setPageSize(newSize);
                                          fetchMediaPlans(1, newSize);
                                        }}
                                        style={{
                                          padding: "5px",
                                          border: "1px solid #ddd",
                                          borderRadius: "4px",
                                        }}>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={500}>500</option>
                                        <option value={1000}>1000</option>
                                        <option value={5000}>5000</option>
                                      </select>
                                    </div>
                                    <div>
                                      <button
                                        onClick={() => {
                                          if (gridApiRef.current) {
                                            // Update page state and fetch data directly
                                            setPage(1);
                                            fetchMediaPlans(1, pageSize);
                                            // Then update the grid's page
                                            gridApiRef.current.paginationGoToFirstPage();
                                          }
                                        }}
                                        disabled={page === 1}
                                        style={{
                                          padding: "5px 10px",
                                          margin: "0 5px",
                                          border: "1px solid #ddd",
                                          borderRadius: "4px",
                                          backgroundColor: page === 1 ? "#f5f5f5" : "white",
                                        }}>
                                        First
                                      </button>
                                      <button
                                        onClick={() => {
                                          if (gridApiRef.current) {
                                            const prevPage = Math.max(1, page - 1);
                                            // Update page state and fetch data directly
                                            setPage(prevPage);
                                            fetchMediaPlans(prevPage, pageSize);
                                            // Then update the grid's page
                                            gridApiRef.current.paginationGoToPreviousPage();
                                          }
                                        }}
                                        disabled={page === 1}
                                        style={{
                                          padding: "5px 10px",
                                          margin: "0 5px",
                                          border: "1px solid #ddd",
                                          borderRadius: "4px",
                                          backgroundColor: page === 1 ? "#f5f5f5" : "white",
                                        }}>
                                        Previous
                                      </button>
                                      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                        let pageNum;
                                        if (totalPages <= 5) {
                                          pageNum = i + 1;
                                        } else if (page <= 3) {
                                          pageNum = i + 1;
                                        } else if (page >= totalPages - 2) {
                                          pageNum = totalPages - 4 + i;
                                        } else {
                                          pageNum = page - 2 + i;
                                        }

                                        return (
                                          <button
                                            key={pageNum}
                                            onClick={() => {
                                              if (gridApiRef.current) {
                                                // Update the page state and fetch data directly
                                                setPage(pageNum);
                                                fetchMediaPlans(pageNum, pageSize);
                                                // Then update the grid's page
                                                gridApiRef.current.paginationGoToPage(pageNum - 1);
                                              }
                                            }}
                                            style={{
                                              padding: "5px 10px",
                                              margin: "0 5px",
                                              border: "1px solid #ddd",
                                              borderRadius: "4px",
                                              backgroundColor:
                                                pageNum === page ? "#007bff" : "white",
                                              color: pageNum === page ? "white" : "black",
                                            }}>
                                            {pageNum}
                                          </button>
                                        );
                                      })}
                                      <button
                                        onClick={() => {
                                          if (gridApiRef.current) {
                                            gridApiRef.current.paginationGoToNextPage();
                                          }
                                        }}
                                        disabled={page === totalPages || totalPages === 0}
                                        style={{
                                          padding: "5px 10px",
                                          margin: "0 5px",
                                          border: "1px solid #ddd",
                                          borderRadius: "4px",
                                          backgroundColor:
                                            page === totalPages || totalPages === 0
                                              ? "#f5f5f5"
                                              : "white",
                                        }}>
                                        Next
                                      </button>
                                      <button
                                        onClick={() => {
                                          if (gridApiRef.current) {
                                            gridApiRef.current.paginationGoToLastPage();
                                          }
                                        }}
                                        disabled={page === totalPages || totalPages === 0}
                                        style={{
                                          padding: "5px 10px",
                                          margin: "0 5px",
                                          border: "1px solid #ddd",
                                          borderRadius: "4px",
                                          backgroundColor:
                                            page === totalPages || totalPages === 0
                                              ? "#f5f5f5"
                                              : "white",
                                        }}>
                                        Last
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="ag-footer-info text-center mt-2"
                                  style={{ display: "none" }}>
                                  {isLoadingMore && <div>Loading more...</div>}
                                  {!hasMore && mediaPlans.length > 0 && !searchQuery && (
                                    <div>All media plans loaded</div>
                                  )}
                                  {(searchQuery ? filteredMediaPlans.length : mediaPlans.length) >
                                    0 && (
                                    <div>
                                      Showing{" "}
                                      {searchQuery ? filteredMediaPlans.length : mediaPlans.length}{" "}
                                      of {totalItems || mediaPlans.length} media plans
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : viewMode === "calendar" ? (
                            <div style={{ height: "700px" }} className="position-relative">
                              {/* Loading Overlay for Calendar View */}
                              {loading && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                                    zIndex: 1000,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}>
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{ width: "3rem", height: "3rem" }}>
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                  <div
                                    style={{
                                      marginTop: "15px",
                                      fontWeight: "bold",
                                    }}>
                                    Loading media plans...
                                  </div>
                                </div>
                              )}
                              <Calendar
                                localizer={localizer}
                                events={mediaPlans.map((plan) => ({
                                  title: plan.campaign_code,
                                  start: new Date(plan.date),
                                  end: new Date(plan.date),
                                  id: plan.id,
                                  client_id: plan.offer_details?.client?.id,
                                  mediaPlanId: plan.id,
                                  clientId: plan.offer_details?.client?.id,
                                }))}
                                onSelectEvent={(event) => {
                                  // Handle click on calendar event to open a new tab
                                  const mediaPlanId = event.id;
                                  const clientId = event.client_id;
                                  const campaignCode = event.title;

                                  if (mediaPlanId && clientId) {
                                    const tabKey = `view-${mediaPlanId}`;
                                    const exists = openViewTabs.some((tab) => tab.key === tabKey);
                                    if (!exists) {
                                      setOpenViewTabs((prev) => [
                                        ...prev,
                                        {
                                          key: tabKey,
                                          label: `View ${campaignCode || mediaPlanId}`,
                                          content: (
                                            <ViewMediaPlan
                                              mediaPlanId={mediaPlanId}
                                              clientId={clientId}
                                            />
                                          ),
                                          closable: true,
                                        },
                                      ]);
                                    }
                                    setForcedTabKey(tabKey);
                                    setActiveViewTabKey(tabKey);
                                  }
                                }}
                                onDoubleClickEvent={(event) => {
                                  // Same functionality as single click for consistency
                                  const mediaPlanId = event.id;
                                  const clientId = event.client_id;
                                  const campaignCode = event.title;

                                  if (mediaPlanId && clientId) {
                                    const tabKey = `view-${mediaPlanId}`;
                                    const exists = openViewTabs.some((tab) => tab.key === tabKey);
                                    if (!exists) {
                                      setOpenViewTabs((prev) => [
                                        ...prev,
                                        {
                                          key: tabKey,
                                          label: `View ${campaignCode || mediaPlanId}`,
                                          content: (
                                            <ViewMediaPlan
                                              mediaPlanId={mediaPlanId}
                                              clientId={clientId}
                                            />
                                          ),
                                          closable: true,
                                        },
                                      ]);
                                    }
                                    setForcedTabKey(tabKey);
                                    setActiveViewTabKey(tabKey);
                                  }
                                }}
                                onNavigate={(date, view) => {
                                  let start, end;

                                  if (view === "month") {
                                    start = moment(date).startOf("month").format("YYYY-MM-DD");
                                    end = moment(date).endOf("month").format("YYYY-MM-DD");
                                  } else if (view === "week") {
                                    start = moment(date).startOf("week").format("YYYY-MM-DD");
                                    end = moment(date).endOf("week").format("YYYY-MM-DD");
                                  } else if (view === "day") {
                                    start = moment(date).format("YYYY-MM-DD");
                                    end = moment(date).format("YYYY-MM-DD");
                                  }

                                  setCalendarDateRange({ start, end, view });
                                }}
                                onView={(view) => {
                                  let start, end;
                                  const date = new Date();

                                  if (view === "month") {
                                    start = moment(date).startOf("month").format("YYYY-MM-DD");
                                    end = moment(date).endOf("month").format("YYYY-MM-DD");
                                  } else if (view === "week") {
                                    start = moment(date).startOf("week").format("YYYY-MM-DD");
                                    end = moment(date).endOf("week").format("YYYY-MM-DD");
                                  } else if (view === "day") {
                                    start = moment(date).format("YYYY-MM-DD");
                                    end = moment(date).format("YYYY-MM-DD");
                                  }

                                  setCalendarDateRange({ start, end, view });
                                }}
                                startAccessor="start"
                                endAccessor="end"
                                views={{
                                  month: true,
                                  week: true,
                                  day: true,
                                }}
                                defaultView="month"
                                style={{ height: 700, margin: "20px" }}
                              />
                            </div>
                          ) : (
                            <TimelineTable
                              setOpenViewTabs={setOpenViewTabs}
                              setForcedTabKey={setForcedTabKey}
                              setActiveViewTabKey={setActiveViewTabKey}
                              loading={loading}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </TabPane>
                  <TabPane tab={campaignTabTitle} key="2" closable={false}>
                    <EditMediaPlan></EditMediaPlan>
                  </TabPane>
                  <TabPane tab="Product Order Prediction" key="3" closable={false}>
                    <ProductOrderPrediction></ProductOrderPrediction>
                  </TabPane>
                  <TabPane tab="RoR of days" key="4" closable={false}>
                    <ROR100Days></ROR100Days>
                  </TabPane>
                  <TabPane tab="Lists" key="5" closable={false}>
                    <Lists />
                  </TabPane>
                  {openViewTabs.map((tab) => (
                    <TabPane tab={tab.label} key={tab.key} closable>
                      {tab.content}
                    </TabPane>
                  ))}
                </Tabs>
              </div>
              <OfferDetailsView
                isVisible={isSidebarVisible}
                onClose={handleCloseRightSideBar}
                offerId={offerId}
                clientId={clientId}
                ref={sidebarRef}
                editMode={isRightSideBarEditMode}
                toggleEdit={toggleSidebarEditMode}
                onResize={setSidebarWidth}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaPlanList;
